import React from 'react';
import axios from 'axios';
import Helmet from 'react-helmet';

// styles
import {
  Grid,
  Row,
  Col,
  Table,
  Button,
  Panel,
  ListGroup,
  ListGroupItem,
  Label,
} from 'react-bootstrap/lib';
import { ConfirmUploadBankCsv } from '../components/ConfirmationModals';

function CsvFormatTableRaw() {
  return (
    <Panel>
      <Panel.Heading>Routing Number,Bank Name,State,City,Street Address</Panel.Heading>
      <ListGroup>
        <ListGroupItem>
          226077862,1199 SEIU FEDERAL CREDIT UNION,NY,NEW YORK,310 WEST 43RD STREET 2ND FL
        </ListGroupItem>
        <ListGroupItem>
          122243761,"1ST CENTURY BK, DIV OF MIDFIRST BK",OK,OKLAHOMA CITY,PO BOX 76149
        </ListGroupItem>
      </ListGroup>
    </Panel>
  );
}

function CsvFormatTable() {
  return (
    <Table striped bordered condensed hover>
      <thead>
        <tr>
          <th>Routing Number</th>
          <th>Bank Name</th>
          <th>State</th>
          <th>City</th>
          <th>Street Address</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>226077862</td>
          <td>1199 SEIU FEDERAL CREDIT UNION</td>
          <td>NY</td>
          <td>New York City</td>
          <td>310 WEST 43RD STREET 2ND FL</td>
        </tr>
        <tr>
          <td>122243761</td>
          <td>"1ST CENTURY BK, DIV OF MIDFIRST BK"</td>
          <td>OK</td>
          <td>Oklahoma City</td>
          <td>PO BOX 76149</td>
        </tr>
      </tbody>
    </Table>
  );
}

export default class UploadBankCsv extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      selectedFile: null,
      isFileSelected: false,
      error: null,
      isSuccessful: false,
    };
  }

  onChangeHandler = (event) => {
    this.setState({
      selectedFile: event.target.files[0],
      isFileSelected: true,
      isSuccessful: false,
      error: null,
    });
  };

  handleSubmission = () => {
    this.setState({ isLoading: true, isSuccessful: false, error: null });

    const formData = new FormData();

    formData.append('file', this.state.selectedFile);

    axios({
      url: '/api/banks/upload-csv',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      method: 'post',
    })
      .then(() => this.setState({ isLoading: false, isSuccessful: true }))
      .catch(() => this.setState({ isLoading: false, error: 'Invalid file' }));
  };

  render() {
    const { isLoading, isFileSelected, error, isSuccessful } = this.state;

    return (
      <div>
        <Helmet title="Upload Bank Information" />
        {isSuccessful ? <ConfirmUploadBankCsv /> : null}
        <Grid>
          <Row>
            <Col xs={12}>
              <p>
                This functionality allows you to upload your own bank information with routing
                numbers so that the information csv file which will be available for later use. It
                will show you the details when doing a guest payment if a matching routing number is
                found.
              </p>

              <br />
              <p>The following format is expected:</p>

              <CsvFormatTable />

              <br />

              <p>Raw CSV format</p>
              <CsvFormatTableRaw />

              <p>
                In the case that there is a field that has a comma (,) in its name, then the field
                must be wrapped in double quotes ("), as is shown above with "1ST CENTURY BK, ..."{' '}
              </p>

              <br />
              <form>
                <input name="file" type="file" accept=".csv" onChange={this.onChangeHandler} />

                <br />
                <Button
                  onClick={this.handleSubmission}
                  disabled={isLoading || !isFileSelected}
                  bsStyle={isSuccessful ? 'success' : 'primary'}
                  bsSize="lg"
                >
                  {isSuccessful ? 'Uploaded' : 'Upload'}
                </Button>
              </form>
              <p>{error && <Label bsStyle="danger">{error}</Label>}</p>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
